var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlert = function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0A24 24 0 0 0 0 24a24 24 0 0 0 24 24 24 24 0 0 0 24-24A24 24 0 0 0 24 0zm-2.803 12h5.606l-1.006 16.6h-3.623L21.197 12zm.123 19.37h5.33V36h-5.33v-4.63z",
    fillRule: "evenodd"
  })));
};
export default SvgAlert;